import { Space } from 'antd';
import CfdContainer from '../components/Cfd/CfdContainer';
import { useParams } from 'react-router-dom';
import React from 'react';
import { ToastContainer } from 'react-toastify';
import { BreakpointProvider } from 'react-socks';


const CfdApp = () => {
  const { routeId } = useParams<{ routeId: string }>();
  // const [routeId, setRouteId] = useState<number>(parseInt(params.routeId, 10));

  // Make the title 'DEV ...' if it is
  const href = window.location.href;
  if (href.match('dev') || !href.match('appspot')) document.title = 'DEV Trajectory Heatmap CFD';
  else document.title = 'Trajectory Heatmap CFD';

  return (
    <BreakpointProvider>
      <Space style={{ width: '100vw' }}>
        <CfdContainer routeId={parseInt(routeId)}/>
        <ToastContainer position="bottom-right" autoClose={2000} closeOnClick={true} pauseOnHover={true}
                        pauseOnFocusLoss={false}/>
      </Space>
    </BreakpointProvider>
  );
};
export default CfdApp;
